<template lang="pug">
div.field.is-fullwidth.is-vcentered
  .control(v-if='companies.length > 1')
    .select.is-fullwidth
      select(v-model="selected")
          option(v-for="cmp of companies", :value="cmp") {{cmp.name}}
  section(v-else-if='selected')
    h2 {{selected.name}}

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CompanyPicker",

  computed: {
    ...mapState(["company", "companies"]),
    selected: {
      get() {
        return this.$store.state.company;
      },
      set(value) {
        this.$store.commit("company", value);
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
h2 {
  color: white !important;
  text-align: left;
  margin-bottom: 0px !important;
}
</style>